import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "children", "onClick"];
import { memo } from 'react';
import styled from 'foundations-theming/utils';
import BaseButton from 'unsubscribe-ui/components/core/buttons/BaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSecondaryButton = styled(BaseButton)(({
  theme
}) => ({
  backgroundColor: theme.color['fill-secondary-default'],
  borderColor: theme.color['border-secondary-default'],
  color: theme.color['text-secondary-default'],
  cursor: 'pointer',
  ':hover': {
    backgroundColor: theme.color['fill-secondary-hover'],
    borderColor: theme.color['border-secondary-default'],
    color: theme.color['text-secondary-default'],
    cursor: 'pointer'
  },
  ':active': {
    backgroundColor: theme.color['fill-secondary-pressed'],
    borderColor: theme.color['border-secondary-default'],
    color: theme.color['text-secondary-default']
  }
}));
const DisabledSecondaryButton = styled(BaseButton).attrs({
  'aria-disabled': true
})(({
  theme
}) => ({
  backgroundColor: theme.color['fill-secondary-disabled'],
  borderColor: theme.color['border-secondary-disabled'],
  color: theme.color['text-secondary-disabled'],
  cursor: 'not-allowed',
  ':hover': {
    backgroundColor: theme.color['fill-secondary-disabled'],
    borderColor: theme.color['border-secondary-disabled'],
    color: theme.color['text-secondary-disabled'],
    cursor: 'not-allowed'
  },
  ':active': {
    backgroundColor: theme.color['fill-secondary-disabled'],
    borderColor: theme.color['border-secondary-disabled'],
    color: theme.color['text-secondary-disabled']
  }
}));
const SecondaryButton = _ref => {
  let {
      disabled,
      children,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (disabled) {
    return /*#__PURE__*/_jsx(DisabledSecondaryButton, Object.assign({}, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(DefaultSecondaryButton, Object.assign({
    onClick: onClick
  }, rest, {
    children: children
  }));
};
export default /*#__PURE__*/memo(SecondaryButton);